/**
 * smooth-scroll.ts — felles inngang til scrolling på fronten (Lenis når den kjører, ellers vanlig window-scroll)
 *
 * PublicSmoothScroll registrerer Lenis-instansen her. Komponenter som skal rulle siden til en posisjon (f.eks. trinn i
 * låste seksjoner) kaller scrollToY, så de ikke krangler med Lenis om hvem som eier scrollingen.
 */

import type Lenis from 'lenis';

let instance: Lenis | null = null;

export function registerLenis(lenis: Lenis | null) {
  instance = lenis;
}

export function scrollToY(y: number) {
  const target = Math.max(0, Math.round(y));
  if (instance) instance.scrollTo(target, { duration: 1.1 });
  else window.scrollTo({ top: target, behavior: 'smooth' });
}
